import { format, formatDistanceToNow } from "date-fns";
import { da } from "date-fns/locale";

export const formatAuditTrailTimestamp = (iso?: string) => {
  if (!iso) {
    return { relative: "-", absolute: "-" };
  }

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return { relative: "-", absolute: "-" };
  }

  return {
    relative: formatDistanceToNow(date, { addSuffix: true, locale: da }),
    absolute: format(date, "d. MMMM yyyy, HH.mm", { locale: da }),
  };
};
